"use strict";
exports.__esModule = true;
exports.CustomAppBar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var CustomAppBar = function (props) {
    var children = props.children, className = props.className, _a = props.position, position = _a === void 0 ? 'relative' : _a, rest = tslib_1.__rest(props, ["children", "className", "position"]);
    return (react_1["default"].createElement("header", tslib_1.__assign({ className: (0, class_names_1["default"])(className, 'flex flex-col w-full z-[1000] top-0 right-0 left-auto', position ? "position: ".concat(position) : "") }, rest), children));
};
exports.CustomAppBar = CustomAppBar;
exports["default"] = exports.CustomAppBar;
//# sourceMappingURL=app-bar.js.map